module.exports = __webpack_public_path__ + "static/media/main22.e7373c62.png";